import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Menu from "../components/Menu/Menu";
import Home from "../components/Home/Home";
import analytics from "../services/firebase";
import { logEvent } from "firebase/analytics";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Linktree from "../shared/components/Linktree/Linktree";
import Whatsapp from "../shared/components/Whatsapp/Whatsapp";

const RoutesListener = () => {
  const location = useLocation();

  useEffect(() => {
    logEvent(analytics, "page_view", {
      page_location: "https://jotavdrone-1dce0.web.app/",
      page_path: "/",
      page_title: "Home",
    });
  }, [location]);

  return <></>;
};

export default ({ pathname }) => {
  return (
    <Router>
      <div className="App background-full ">
        {pathname !== "/jotav" ? <Menu /> : <div></div>}
        <RoutesListener />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="/jotav" element={<Linktree />} />
        </Routes>
        <ToastContainer />
        {pathname !== "/jotav" ? <Whatsapp /> : <div></div>}
      </div>
    </Router>
  );
};
